<template>
  <div>
    <h1>
      Offers
      <router-link :to="{ name: 'create-offers' }" tag="button" type="button" class="btn btn-sm btn-primary">
        Create
      </router-link>
    </h1>

    <div class="alert alert-danger" v-if="error">
      <p class="mb-0">
        {{ error }}
      </p>
    </div>

    <datatable class="mt-4" :cols="columns" :rows="offers.filter((c) => c.deleted_at == null)" />
  </div>
</template>

<script>
import store from "../../../store";
import { mapState } from "vuex";
import DataTable from "../../DataTable";
import { createDatatableButtons, getError } from "../../../helpers";

export default {
  components: {
    datatable: DataTable,
  },

  data() {
    return {
      name: null,
      error: null,

      columns: [
        {
          headerName: "ID",
          field: "id",
          sortable: true,
          filter: true,
          resizable: true,
          minWidth: 50,
          maxWidth: 75,
        },
        {
          headerName: "Product",
          field: "product_details.name",
          sortable: true,
          filter: true,
          resizable: true,
          minWidth: 150,
        },
        {
          headerName: "Offer Start Date",
          field: "start_Date",
          sortable: true,
          filter: true,
          resizable: true,
          minWidth: 150,
        },
        {
          headerName: "Offer End Date",
          field: "end_Date",
          sortable: true,
          filter: true,
          resizable: true,
          minWidth: 150,
        },
        {
          headerName: "New Price",
          field: "new_price",
          sortable: true,
          filter: true,
          resizable: true,
          minWidth: 150,
        },
        {
          headerName: "Notes",
          field: "notes",
          sortable: true,
          filter: true,
          resizable: true,
          minWidth: 150,
        },
        {
          headerName: "Actions",
          field: "id",
          minWidth: 175,
          maxWidth: 175,

          cellRenderer: (params) => {
            const buttons = [];

            buttons.push({
              name: "Edit",
              type: "secondary",
              handler: () => {
                this.$router.push({
                  name: "edit-offers",
                  params: {
                    id: params.data.id,
                  },
                });
              },
            });


            buttons.push({
              name: "Delete",
              type: "danger",
              handler: () => {
                if (
                  confirm(
                    `Are you sure you want to delete this offer entry?`
                  )
                ) {
                  this.error = null;

                  this.$store
                    .dispatch(`offers/delete`, { offersId: params.data.id })
                    .catch((e) => {
                      this.error = getError(e);
                    });
                }
              },
            });
            return createDatatableButtons(buttons);
          },
        },
      ],
    };
  },

  computed: {
    ...mapState({
      offers: (state) => state.offers.offers.map((a) => ({ ...a })),
    }),
  },

  async beforeRouteEnter(to, from, next) {
    await store.dispatch("offers/fetchAll");
    next();
  },

  meta: {
    title: "Offers",

    meta: [{ property: "og:title", content: "Offers / Shayah" }],
  },
};
</script>

<style scoped>

</style>